import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  gap: 4px;

  &[data-dragging='true'] {
    cursor: grabbing;
  }
`

export const DragHandle = styled.button`
  color: var(--p-neutral-500);
  cursor: grab;
  padding-top: 5px;

  background: transparent;
  line-height: 1;
  opacity: 0;
  visibility: hidden;
  transition: opacity 120ms ease;
  cursor: grab;

  ${Row}:hover & {
    opacity: 1;
    visibility: visible;
  }

  ${Row}[data-dragging='true'] & {
    opacity: 1;
    visibility: visible;
    cursor: grabbing;
  }
`

export const RowContent = styled.div`
  width: 100%;
  min-width: 0;
`
